<template>
    <div>
        <div class="modal fade" id="dynamicFieldModal" tabindex="-1" role="dialog" aria-labelledby="Dynamic Field" aria-hidden="true" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Dynamic Field</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeFieldModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row w-100 p-0 m-0" v-if="fieldData.selectedType.name !== 'Checkbox'">
                            <div class="col-md-12 ml-0 pl-0">
                                Required field <b-form-checkbox id="field-required" v-model="fieldData.isRequired"/>
                            </div>
                        </div>
                        <div class="row w-100 p-0 m-0 mt-3">
                            <div class="col-md-6 ml-0 pl-0">
                                <div class="text-l w-100 p-0 m-0 mb-1">
                                    Field Type
                                </div>
                                <div class="w-100">
                                    <multiselect class="calender-filter"
                                                 v-model="fieldData.selectedType"
                                                 :options="fieldTypes"
                                                 placeholder="Select Field Type"
                                                 label="name"
                                                 track-by="name"
                                                 :multiple="false"
                                                 :close-on-select="true"
                                                 :clear-on-select="false"
                                                 :preserve-search="false"
                                                 :taggable="true"
                                                 open-direction="below"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-6 mr-0 pr-0">
                                <div class="text-l w-100 p-0 m-0 mb-1">
                                    <span class="align-left m-0 p-0">Name of field</span><span class="float-right field-info-icon" title="A short name to appear in the field list"><i class="fa fa-info-circle" aria-hidden="true"></i></span>
                                </div>
                                <div class="w-100">
                                    <input type="text" class="form-control w-100" v-model="fieldData.name">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 w-100 p-0 m-0 mt-3">
                            <div class="text-l w-100 p-0 m-0 mb-1">
                                <span class="align-left m-0 p-0">Label of field</span><span class="float-right field-info-icon" title="Label to show above the options"><i class="fa fa-info-circle" aria-hidden="true"></i></span>
                            </div>
                            <div class="w-100">
                                <input type="text" class="form-control w-100" v-model="fieldData.label">
                            </div>
                        </div>
                        <div class="row w-100 p-0 m-0 mt-3">
                            <div class="text-l w-100 p-0 m-0 mb-1">
                                <span class="align-left m-0 p-0">Options</span><span class="float-right field-info-icon" title="Options for checkbox, radio button and dropdown. Minimum 2 options required for radio button and 1 for dropdown/checkbox"><i class="fa fa-info-circle" aria-hidden="true"></i></span>
                            </div>
                            <div class="col-md-6 float-left mt-2" v-for="(fieldOption, index) in fieldData.options">
                                <div class="row p-0 m-0 mb-1" style="display: flex;align-items: baseline;">
                                    <div class="col-md-4 p-0 m-0 text-sm">Option {{index+1}}</div>
                                    <div class="col-md-8 p-0 m-0 text-right text-sm" v-if="fieldData.selectedType.name == 'Checkbox'">
                                        Required field <b-form-checkbox :id="'option-required-'+index" v-model="fieldOption.required"/>
                                    </div>
                                </div>
                                <input type="text" id class="form-control float-left" style="width: 80%" v-model="fieldOption.name">
                                <button class="form-control btn-danger float-right" style="width: 15%" @click="removeFieldOption(index)"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                            </div>
                            <div class="col-md-12 w-100">
                                <button @click="addFieldOption()" class="form-control btn-primary mt-4" style="width: 50%; margin:0 auto;"> Add Option </button>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button v-if="updateDynamicField" type="button" class="btn btn-danger" data-dismiss="modal" @click="deleteDynamicField()">Delete field</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeFieldModal">Close</button>
                        <button v-if="updateDynamicField" type="button" class="btn btn-primary" @click="updateDynamicFieldMethod()">Update field</button>
                        <button v-else type="button" class="btn btn-primary" @click="saveDynamicField()">Save field</button>
                    </div>
                </div>
            </div>
        </div>
        <div id="uploadDocModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">
                            Upload Word Document
                        </h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <file-pond
                            name="file"
                            ref="pond"
                            :server="server"
                            :onprocessfile="handleOnProcessFile"
                            allowRevert="false"
                            allowMultiple="false"
                            allowRemove="false"
                            class-name="my-pond"
                            dropOnElement="true"
                            dropOnPage="true"
                            label-idle="Drop or select a word document"
                            labelFileTypeNotAllowed="Invalid File Type"
                            fileValidateTypeLabelExpectedTypes="Only DOCX Documents Are Allowed."/>
                    </div>
                </div>
            </div>
        </div>
        <div id="proposal-settings-template-manage-div" class="p-3">
            <div class="row">
                <div class="col-md-6 float-left mb-3">
                    <h5 class="mt-1 float-left mr-3">{{ selectedProposalContentText.template_name }}</h5>
                </div>
                <div class="col-md-6 float-right text-right pt-1">
                    <div class="pr-0">
                        <div class="col-md-4 p-0 m-0 float-left pt-2 pr-3">
                            {{savingPrizmDoc}}
                        </div>
                        <div class="col-md-5 p-0 m-0 float-left text-left">
                            <button type="button" @click="openUploadDocModal()" class="bg-followup-nav hover:bg-followup-nav-darker px-2 py-1 text-white focus:outline-none rounded add-new-template-button">
                                <i class="fa fa-cloud-upload" aria-hidden="true"></i> Upload Word Document
                            </button>
                        </div>
                        <div class="col-md-3 p-0 m-0 float-left text-left">
                            <button id="add-proposal-template" name="add-proposal-template" @click="saveOnlyOfficeDocument('button')"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 text-white focus:outline-none rounded add-new-template-button">
                                Save Content
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 float-left mb-3">
                </div>
                <div class="col-md-6 float-right text-right pt-1 embedded-header-footer">
                    <i class="fa fa-info-circle text-teal embeddedTitle" title="When turn On, the header and footer image in the document below will be used instead of header and footer image from the proposal template." aria-hidden="true"></i>
                    <span class="mr-4 ml-2">{{ (showEmbeddedHeaderFooter)? 'On':'Off' }}</span>
                    <b-form-checkbox @change="changeEmbeddedHeaderFooter" name="check-button" v-model="showEmbeddedHeaderFooter" id="proposalButtonSwitch" class="inline-block p-0 embedded-header-footer" switch>
                    </b-form-checkbox>
                    <label for="proposalButtonSwitch" class="inline-block text-black font-weight-light cursor-pointer ">Use Embedded Header & Footer Image in Proposal</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-10 pr-0">
                    <div class="w-100">
                        <div id="editor-control-container" style="width:100%;height:150vh"></div>
                    </div>
                </div>
                <div class="col-md-2 mt-3" style="height: 95vh; overflow: scroll;">
                    <div class="overflow-hidden">
                        <div class="text-xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white mb-3">

                            <button
                                class="" style="color:white;">Fields
                            </button>
                        </div>
                        <div @click="toolButton('accountManager', 'Account Manager')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Account Manager</div>
                        <div @click="toolButton('baseBid', 'Base Bid')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Base Bid</div>
                        <div @click="toolButton('companyAddress', 'Company Address')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Company Address</div>
                        <div @click="toolButton('companyCity', 'Company City')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Company City</div>
                        <div @click="toolButton('contactCompany', 'Company Name')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Company Name</div>
                        <div @click="toolButton('companyNumber', 'Company Number')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Company Number</div>
                        <div @click="toolButton('companyState', 'Company State')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Company State</div>
                        <div @click="toolButton('companyZip', 'Company Zip')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Company Zip</div>
                        <div @click="toolButton('contactEmail', 'Contact Email')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Contact Email</div>
                       <div @click="toolButton('addInitials', 'Contact Initials')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Contact Initials</div>
                        <div @click="toolButton('contactName', 'Contact Name')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Contact Name</div>
                        <div @click="toolButton('contactNumber', 'Contact Number')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Contact Number</div>
                       <div @click="toolButton('addSignature', 'Contact Signature')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Contact Signature</div>
                        <div @click="toolButton('contactTitle', 'Contact Title')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Contact Title</div>
                        <div @click="toolButton('estimator', 'Estimator')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Estimator</div>
                        <div @click="toolButton('myEmail', 'My Email')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">My Email</div>
                        <div @click="toolButton('myName', 'My Name')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">My Name</div>
                        <div @click="toolButton('myNumber', 'My Number')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">My Number</div>
                       <div @click="toolButton('mySignature', 'My Signature')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">My Signature</div>
                        <div @click="toolButton('myTitle', 'My Title')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">My Title</div>
                        <div @click="toolButton('projectAddress', 'Project Address')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Project Address</div>
                        <div @click="toolButton('city', 'Project City')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Project City</div>
                        <div @click="toolButton('projectID', 'Project ID')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Project ID</div>
                        <div @click="toolButton('projectName', 'Project Name')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Project Name</div>
                        <div @click="toolButton('state', 'Project State')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Project State</div>
                        <div @click="toolButton('zipCode', 'Project Zip Code')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Project Zip Code</div>
                        <div @click="toolButton('addDate', 'Signature Date')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Signature Date</div>
                        <div @click="toolButton('state', 'Take Off Person')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Take off person</div>
                        <div @click="toolButton('todayDate', 'Todays Date')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">Todays Date</div>
                    </div>
                    <div class="overflow-hidden mt-3">
                        <div class="text-xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white mb-3">
                            <button
                                class="" style="color:white;">Custom Fields
                            </button>
                        </div>
                        <span v-if="customFieldsLables.length > 0">
                            <div v-for="customFieldsLable in customFieldsLables" v-if="customFieldsLable.enabled" @click="toolButton(customFieldsLable.label_value.replace(/\s+/g, '-').toLowerCase(), customFieldsLable.name)" class="field-tooltip col-md-12 tool-buttons inline-block float-left">{{ customFieldsLable.name }}</div>
                        </span>
                    </div>
                    <div class="overflow-hidden mt-3">
                        <div>
                            <div class="text-xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white">

                                <div class="" style="color:white;">
                                    Signatures
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12 p-4 signature-field-div" style="padding-left: 0 !important; padding-right: 0 !important; max-height: 52vh;">
                            <multiselect :options="signatureUsers"
                                         placeholder="Add Signature"
                                         v-model="selectedSignatureUser"
                                         :show-labels="false"
                                         class="mb-2 cursor-pointer"
                                         :multiple="false"
                                         :close-on-select="true"
                                         :clear-on-select="false"
                                         :preserve-search="false"
                                         :taggable="false"
                                         open-direction="below"
                                         label="displayName"
                                         track-by="id"
                                         :preselect-first="false"
                                         group-values="contact_options"
                                         group-label="contact_type"
                                         :group-select="false"
                            >
                            </multiselect>
                        </div>
                        <div class="col-md-12 overflow-hidden" style="padding-left: 0 !important; padding-right: 0 !important;" v-if="allSignerFields.length > 0" v-for="(signerField, index) in allSignerFields">
                            <div @click="toolButton(slugify(signerField.name)+'_signature', signerField.name+' Signature')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">{{signerField.name+' Signature'}}</div>
                            <div @click="toolButton(slugify(signerField.name)+'_initials', signerField.name+' Initials')" class="field-tooltip col-md-12 tool-buttons inline-block float-left" data-toggle="tooltip" data-placement="top">{{signerField.name+' Initials'}}</div>
                        </div>
                    </div>
                    <div class="overflow-hidden mt-3">
                        <div class="text-xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white mb-3">
                            <button @click="addDynamicFieldModal"
                                class="" style="color:white;">Dynamic Fields+
                            </button>
                        </div>
                        <span v-if="dynamicFields.length > 0">
                            <div v-for="dynamicField in dynamicFields"  class="field-tooltip col-md-12 inline-block float-left dynamic-field-div" data-toggle="tooltip" data-placement="top"><span class="text-left col-md-8 m-0 p-0 dynamic-field-name" @click="toolButtonDynamicFields(dynamicField.name.replace(/\s+/g, '-').toLowerCase(), dynamicField.code)">{{ dynamicField.name }}</span><span class="col-md-4 m-0 p-0 dynamic-field-edit " v-if="role" @click="editDynamicField(dynamicField)"><i class="fa fa-cog" aria-hidden="true"></i></span></div>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="createNewContactSignatureModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Add New Contact For Signature</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeCreateNewContactSignatureModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <label>Contact Name</label>
                                <input type="text" class="form-control" v-model="newContactName">
                            </div>
                            <div class="col-md-12 mt-4">
                                <label>Contact Email</label>
                                <input type="email" class="form-control" v-model="newContactEmail">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-inline-block text-right">
                        <span class="btn btn-outline-primary float-left d-flex align-items-center py-1 px-2" @click="openSelectContactModal()">
                            <i class="fa fa-user fa-2x mr-2"></i> Select Contact
                        </span>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeCreateNewContactSignatureModal">Close</button>
                        <button type="button" class="btn btn-primary" @click="createNewContact">Add Contact</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal" id="selectContactModal" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style="border-radius: 12px; overflow: hidden;width: 400px;">
                    <div class="modal-header">
                        <div class="row">
                            <div class="col-md-12" style="text-align: center; font-size:20px; margin-top: 10px;">Select a Contact</div>
                            <div class="col-md-12" style="text-align: center; margin-top: 32px;">
                                <button type="button" class="btn btn-primary" style="padding: 20px;margin-right: 12px;"
                                        @click="openNewCompanyContactModal"> Company Contact</button>
                                <button type="button" class="btn btn-primary" style="padding: 20px;"
                                        @click="openEmailContactModal">Email Contact</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <company-contact-modal
            ref="CompanyContactModal"
            :masks="this.masks"
            :symbols="this.symbols"
            @selected="parseContacts"
            v-if="showComponent"
        ></company-contact-modal>

        <project-contact-modal
            ref="EmailContactModal"
            :masks="masks"
            :symbols="symbols"
            :exchange="exchange"
            :externalEmailService="externalEmailService"
            @selected="parseContacts"
            v-if="showComponent"
        ></project-contact-modal>
    </div>
</template>

<script>

import axios from "axios";
import Swal from "sweetalert2";
import Multiselect    from 'vue-multiselect';
import CompanyContactModal from "../../company/company-contact-modal.vue";
import ProjectContactModal from "../../project/external-email/project-contact-modal.vue";

export default {
    name: "proposal-settings-content-text-manage",
    props:['proposalContentText', 'role'],
    components: {ProjectContactModal, CompanyContactModal, Multiselect},
    data() {
        return {
            selectedProposalContentText: (this.proposalContentText)? this.proposalContentText:null,
            documentId: (this.proposalContentText.file_url)? this.proposalContentText.file_url:null,
            prizmEditorBaseURL: null,
            savingPrizmDoc: 'Saved',
            editorControl: null,
            server: {
                process: (fieldName, file, metadata, load, error, progress) => {
                    let self = this;
                    const formData = new FormData();
                    let filename = file.name;
                    let extension = filename.match(/\.([^.]+)$/)[1];
                    formData.append('type', extension);
                    formData.append('file', file, file.name);
                    formData.append('content', self.selectedProposalContentText.id);
                    const request = new XMLHttpRequest();
                    request.open('POST', route('api.proposal-content.text.upload-custom-document'));
                    let token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
                    request.setRequestHeader('X-CSRF-TOKEN', token);
                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            load(request.responseText);
                            let response = JSON.parse(request.response);
                            self.documentURL = response.documentURL;
                            self.docEditor.destroyEditor();
                            self.loadOnlyOfficeEditor();
                        } else {
                            error('Please try again.');
                        }
                    };
                    request.send(formData);
                }
            },
            customFieldsLables: [],
            fieldTypes:[
                {
                    "name":"Checkbox"
                },{
                    "name":"Radio"
                },{
                    "name":"Dropdown"
                }
            ],
            fieldData: {
                isRequired: true,
                selectedType: { name: null},
                name: '',
                label: '',
                title: '',
                options: [
                    {
                        name: '',
                        required: false
                    },
                    {
                        name: '',
                        required: false
                    }
                ]
            },
            dynamicFields: [],
            updateDynamicField: false,
            updateDynamicFieldId: null,
            docEditor: null,
            editorConnectors: null,
            docState: null,
            documentURL: null,
            documentKey: null,
            showEmbeddedHeaderFooter: false,
            formFieldCount: 0,
            documentType: 'docx',
            signatureUsers: [],
            selectedSignatureUser: null,
            newContactName: null,
            newContactEmail: null,
            allSignerFields: [],
            customSignatureFields: [],
            customInitialFields: [],
            masks: [],
            symbols: [],
            exchange: null,
            externalEmailService: null,
            showComponent: false,
            signatureInDoc: null,
        }
    },
    mounted(){
        this.prizmEditorBaseURL = window.location.origin;
        // this.getDocumentIdFromDB();
        this.fetchProjectCustomFields();
        this.getDynamicFields();
        this.getDocument();
        $('.embeddedTitle').tooltip();
        this.getContactsDataForSignature();
        this.getAllSignerFields();
    },
    methods: {
        getDocumentIdFromDB(){
            let self = this;
            axios.post(route('api.proposal-content.text.get-document-id'),{content:self.selectedProposalContentText})
                .then((response) => {
                    if(response.data.documentId !== null){
                        self.documentId =  response.data.documentId;
                        self.createPrizmEditorSession();
                    }else{
                        self.uploadPrizmEditorDocument();
                    }
                });
        },
        createPrizmEditorSession(){
            let self = this;
            this.$nextTick(()=>{
                axios.post(route('prizm.create-session'),{documentId:self.documentId})
                    .then((response) => {
                        self.sessionId = response.data.response.sessionId;
                        self.createPrizmEditor();
                    });
            });
        },
        async createPrizmEditor(){
            $('#editor-control-container').empty();
            let self = this;
            const editorPrizm = await Accusoft.DocumentEditorControl.create({
                baseUrl: self.prizmEditorBaseURL,
                sessionId: self.sessionId,
                container: document.getElementById('editor-control-container')
            })
            console.log(editorPrizm);
            self.editorControl = editorPrizm;
            editorPrizm.on('saveStarted', () => {
               this.savingPrizmDoc = 'Saving...';
            });
            editorPrizm.on('saveCompleted', () => {
                this.savingPrizmDoc = 'Saved';
            });
            editorPrizm.on('saveFailed', () => {
                this.savingPrizmDoc = 'Failed!';
            });

        },
        uploadPrizmEditorDocument(){
            let self = this;
            axios.post(route('prizm.upload-document'), {})
                .then((response) => {
                    self.documentId = response.data.response.documentId;
                    self.updateDocumentIdInSection();
                    self.createPrizmEditorSession();
                });
        },
        updateDocumentIdInSection(){
            let self = this;
            this.$nextTick(()=>{
                axios.post(route('api.proposal-content.text.update-document-id'),{content:self.selectedProposalContentText,documentId:self.documentId})
                    .then((response) => {
                        self.sessionId = response.data.sessionId;
                        self.createPrizmEditor();
                    });
            });
        },
        prizmEditorSave(){
            this.editorControl.saveDocument();
        },
        openUploadDocModal(){
            $('#uploadDocModal').modal("show");
        },
        handleOnProcessFile(){
            $('#uploadDocModal').modal("hide");
            $('#editor-control-container').empty();
            this.docEditor.destroyEditor();
            this.loadOnlyOfficeEditor();
        },
        toolButton(button, content){

            let fieldCheck = false;
            if(/\bSignature\b/.test(content) || /\bInitials\b/.test(content)){
                if(this.signatureInDoc){
                    if(this.signatureInDoc.customSignatureFields){
                        if(this.signatureInDoc.customSignatureFields.length > 0){
                            this.signatureInDoc.customSignatureFields.forEach(item => {
                                if(content == 'Contact Signature' || content == 'My Signature'){
                                    if(item.name !== 'Contact Signature' && item.name !== 'My Signature' && item.name !== 'Contact Initials'){
                                        fieldCheck = true;
                                    }
                                }else{
                                    if(item.name == 'Contact Signature'){
                                        fieldCheck = true;
                                    }
                                    if(item.name == 'My Signature'){
                                        fieldCheck = true;
                                    }
                                    if(item.name == 'Contact Initials'){
                                        fieldCheck = true;
                                    }
                                }
                            })
                        }
                    }
                }
            }

            if(fieldCheck){
                this.getToast().fire({
                    type: 'error',
                    title: 'Custom signatures and contact signature field cannot be used together.'
                });
                return false;
            }

            window.Asc.scope.text = '{{'+content+'}}';
            this.editorConnectors.callCommand(function(){
                var oDocument = Api.GetDocument();
                var oParagraph = Api.CreateParagraph();
                oParagraph.AddText(Asc.scope.text);
                oDocument.InsertContent([oParagraph]);
                Api.Save();
            }, function(){ console.log("callback command"); });
        },
        fetchProjectCustomFields(){
            this.labelsReorder = [];
            this.customLabelsReorder = [];
            axios.get(route('api.project-custom-field.index'))
                .then((response) => {
                    this.customFieldsLables = [];
                    this.customFieldsLables = response.data.data.sort((a,b) => a.label_order - b.label_order);
                });
        },
        formatDate(dateValue){
            return moment.utc(dateValue).local().format('MM/DD/YYYY');
        },
        addDynamicFieldModal(){
            $('#dynamicFieldModal').modal('show');
            $('.field-info-icon').tooltip();
        },
        addFieldOption(){
            let option = {
                name: '',
                required: false
            }
            this.fieldData.options.push(option);
        },
        removeFieldOption(index){
            this.fieldData.options.splice(index, 1);
        },
        closeFieldModal(){
            $('#dynamicFieldModal').modal('hide');
            let fieldData = {
                isRequired: true,
                selectedType: { name: null},
                name: '',
                label: '',
                title: '',
                options: [
                    {
                        name: '',
                        required: false
                    },
                    {
                        name: '',
                        required: false
                    }
                ]
            };
            this.fieldData = fieldData;
            this.updateDynamicField = false;
            this.updateDynamicFieldId = null;
        },
        saveDynamicField(){
            if(this.fieldData.selectedType){
                let numberOfOption = 0;
                if(this.fieldData.selectedType.name == 'Radio'){
                    numberOfOption = 2;
                }else{
                    numberOfOption = 1;
                }

                if(this.fieldData.options.length >= numberOfOption){
                    var optionData = false;
                    this.fieldData.options.forEach((item, index) => {
                        if(!item.name || item.name.trim() == ''){
                            let optionNo = index+1;
                            this.getToast().fire({
                                type: 'error',
                                title: 'Please add value to option '+optionNo
                            });
                            optionData = true;
                            return false;
                        }

                    });
                    if(optionData){
                        return false;
                    }
                }else{
                    if(this.fieldData.selectedType.name == 'Radio'){
                        this.getToast().fire({
                            type: 'error',
                            title: 'Please add minimum of 2 options.'
                        });
                        return false;
                    }else{
                        this.getToast().fire({
                            type: 'error',
                            title: 'Please add minimum of 1 option.'
                        });
                        return false;
                    }
                }

                if(!this.fieldData.name || this.fieldData.name == '' || !this.fieldData.label || this.fieldData.label == ''){
                    this.getToast().fire({
                        type: 'error',
                        title: 'Please enter field name'
                    });
                    return false;
                }
            }else{
                this.getToast().fire({
                    type: 'error',
                    title: 'Please select field type'
                });
                return false;
            }

            axios.post(route('proposal-generator.crate-dynamic-field'), {data: this.fieldData}).then(response => {
                this.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                this.closeFieldModal();
                this.getDynamicFields();
            });
        },
        getDynamicFields(){
            axios.post(route('proposal-generator.get-dynamic-field'), {data: this.fieldData}).then(response => {
                console.log(response);
                this.dynamicFields = response.data.dynamicFields
            });
        },
        editDynamicField(dynamicField){
            this.updateDynamicField = true;
            this.updateDynamicFieldId = dynamicField.id;
            let fieldData = {
                isRequired: (dynamicField.is_required == 1)? true:false,
                selectedType: { name: dynamicField.type },
                name: dynamicField.name,
                label: dynamicField.label,
                options: dynamicField.proposal_generator_dynamic_field_values
            };
            this.fieldData = fieldData;
            this.addDynamicFieldModal();
        },
        deleteDynamicField(){
            axios.post(route('proposal-generator.delete-dynamic-field'), {fieldId: this.updateDynamicFieldId}).then(response => {
                this.getToast().fire({
                    type: 'success',
                    title: 'Field deleted successfully'
                });
                this.getDynamicFields();
            });
        },
        updateDynamicFieldMethod(){
            if(this.fieldData.selectedType){
                let numberOfOption = 0;
                if(this.fieldData.selectedType.name == 'Radio'){
                    numberOfOption = 2;
                }else{
                    numberOfOption = 1;
                }

                if(this.fieldData.options.length >= numberOfOption){
                    var optionData = false;
                    this.fieldData.options.forEach((item, index) => {
                        if(!item.name || item.name.trim() == ''){
                            let optionNo = index+1;
                            this.getToast().fire({
                                type: 'error',
                                title: 'Please add value to option '+optionNo
                            });
                            optionData = true;
                            return false;
                        }

                    });
                    if(optionData){
                        return false;
                    }
                }else{
                    if(this.fieldData.selectedType.name == 'Radio'){
                        this.getToast().fire({
                            type: 'error',
                            title: 'Please add minimum of 2 options.'
                        });
                        return false;
                    }else{
                        this.getToast().fire({
                            type: 'error',
                            title: 'Please add minimum of 1 option.'
                        });
                        return false;
                    }
                }

                if(!this.fieldData.name || this.fieldData.name == '' || !this.fieldData.label || this.fieldData.label == ''){
                    this.getToast().fire({
                        type: 'error',
                        title: 'Please enter field name'
                    });
                    return false;
                }
            }else{
                this.getToast().fire({
                    type: 'error',
                    title: 'Please select field type'
                });
                return false;
            }

            axios.post(route('proposal-generator.update-dynamic-field'), {data: this.fieldData, fieldId: this.updateDynamicFieldId}).then(response => {
                this.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                this.closeFieldModal();
                this.getDynamicFields();
            });
        },
        toolButtonDynamicField(button, text){
            let content = { type: 'text', content: text.replace(/\\n/g, "\n")};
            this.editorControl.insertContent(content);
        },
        loadOnlyOfficeEditor(){
            let self = this;
            let documentKey = self.makeid(10);
            this.documentKey = documentKey;
            const config = {
                document: {
                    fileType: this.documentType,
                    key: documentKey,
                    title: "Title."+this.documentType,
                    url: this.documentURL,
                },
                documentType: "word",
                editorConfig: {
                    mode: "edit",
                    callbackUrl: window.location.origin+"/only-office-callback-for-content/"+this.proposalContentText.id+'/text',
                    coEditing: {
                        mode: 'fast',
                        change: true
                    },
                    customization: {
                        uiTheme: 'theme-followup',
                        customer: {
                            name: 'FollowupCRM',
                            logo: 'https://prod-followupcrm.s3.us-east-2.amazonaws.com/profiles/zTT3YUfpIcTOcWCHW2Rmwokude2D2wvk76Y0n1J3.png'
                        },
                        forcesave: true,
                        logo: {
                            image: "https://prod-followupcrm.s3.us-east-2.amazonaws.com/profiles/zTT3YUfpIcTOcWCHW2Rmwokude2D2wvk76Y0n1J3.png",
                            imageDark: "https://prod-followupcrm.s3.us-east-2.amazonaws.com/profiles/zTT3YUfpIcTOcWCHW2Rmwokude2D2wvk76Y0n1J3.png",
                            url: "https://app.followupcrm.com/"
                        },
                        plugins: true,
                        unit: 'inch',
                        anonymous: {
                            request: true,
                            label: "Guest"
                        },
                        hideRightMenu: true
                    }
                },
                height: "900px",
                type: "desktop",
                width: "100%",
                customization: {
                    anonymous: {
                        request: true,
                        label: "Guest"
                    },
                    autosave: true
                },
                events: {
                    'onDocumentReady': function(){
                        self.editorConnectors = self.docEditor.createConnector();
                        self.setPageSizeToUSLetter();
                        window.Asc.scope.customSignatureFields =[];
                        window.Asc.scope.customInitialFields =[];
                    },
                    'onDocumentStateChange': function(){
                        self.saveOnlyOfficeDocument(null);
                    }
                },
                permission: {
                    edit: true,
                    protect: false,
                    review: false
                }
            };
            this.docEditor = new DocsAPI.DocEditor("editor-control-container", config);
            this.$nextTick(() => {
                // this.setEventsForOnlyOffice();
            });
        },
        setEventsForOnlyOffice(){
            this.editorConnectors = this.docEditor.createConnector();
        },
        makeid(length) {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
                counter += 1;
            }
            return result;
        },
        getDocument(){
            axios.post(route('proposal.only-office.get-document-for-content'),{contentId:this.proposalContentText.id}).then((response) => {
                this.documentURL = response.data.documentURL;
                this.showEmbeddedHeaderFooter = (response.data.showEmbeddedHeaderFooter === 1)? true:false;
                this.documentType = response.data.documentType;
                this.$nextTick(() => {
                    this.loadOnlyOfficeEditor();
                });
            });
        },
        saveOnlyOfficeDocument(fromWhere){
            let self = this;
            this.savingPrizmDoc = 'Saving...';
            this.editorConnectors.executeMethod("GetAllForms", null, function (data) {
                if(data.length > 0){
                    self.formFieldCount = 1;
                }else{
                    self.formFieldCount = 0;
                }
            });

            this.$nextTick(() => {
                let self = this;
                Asc.scope.allCustomSignature =self.allSignerFields;

                this.editorConnectors.callCommand(function() {
                    var oDocument = Api.GetDocument();
                    function searchText(searchString) {
                        var found = false;
                        var paragraphs = oDocument.GetAllParagraphs();
                        for (var i = 0; i < paragraphs.length; i++) {
                            var paragraphText = paragraphs[i].GetText();
                            if (paragraphText.includes(searchString)) {
                                found = true;
                                break;
                            }
                        }
                        return found;
                    }

                    if (Asc.scope.allCustomSignature.length > 0){
                        Asc.scope.allCustomSignature.forEach(signature => {
                            var specificText = signature.name+" Signature";
                            var textFound = searchText(specificText);
                            if (textFound) {
                                Asc.scope.customSignatureFields.push({type: 'signature', name: signature.name, email: signature.email});
                                console.log(Asc.scope.customSignatureFields);
                            }
                            var specificInitials = signature.name+" Initials";
                            var initialFound = searchText(specificInitials);
                            if (initialFound) {
                                Asc.scope.customInitialFields.push({type: 'initial', name: signature.name, email: signature.email});
                            }
                        })
                    }

                    var specificText = "Contact Signature";
                    var textFound = searchText(specificText);
                    if (textFound) {
                        Asc.scope.customSignatureFields.push({type: 'signature', name: 'Contact Signature', email: ''});
                        console.log(Asc.scope.customSignatureFields);
                    }
                    var specificText = "My Signature";
                    var textFound = searchText(specificText);
                    if (textFound) {
                        Asc.scope.customSignatureFields.push({type: 'signature', name: 'My Signature', email: ''});
                    }

                    return {
                        customSignatureFields: Asc.scope.customSignatureFields,
                        customInitialFields: Asc.scope.customInitialFields,
                    };
                }, function(result) {
                    self.setCustomSignatureFieldsArray(result);
                });
            });

            axios.post(route('proposal.only-office.save-document'), {documentKey: this.documentKey, formFieldCount: this.formFieldCount, typeId: this.proposalContentText.id, type: 'contentDoc'})
                .then((response) => {
                    if(fromWhere){
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                    }
                    this.savingPrizmDoc = 'Saved';
                });
        },
        toolButtonDynamicFields(button, text){
            let content = { type: 'text', content: text.replace(/\\n/g, "\n")};
            let self = this;
            window.Asc.scope.text = content.content;
            this.editorConnectors.callCommand(function(){
                var oDocument = Api.GetDocument();
                var oParagraph = Api.CreateParagraph();
                oParagraph.AddText(Asc.scope.text);
                oDocument.InsertContent([oParagraph]);
                Api.Save();
            }, function(){ console.log("callback command"); });
        },
        changeEmbeddedHeaderFooter(){
            let self = this;
            this.$nextTick(()=>{
                axios.post(route('api.proposal-content.text.update-embedded-header-footer'),{contentId:self.selectedProposalContentText.id,showEmbeddedHeaderFooter:self.showEmbeddedHeaderFooter})
                    .then((response) => {
                        self.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                    });
            });
        },
        setPageSizeToUSLetter(){
            let self = this;
            self.editorConnectors.callCommand(function () {
                var oDocument = Api.GetDocument();
                var oSection = oDocument.GetFinalSection();
                oSection.SetPageSize(12240, 15840);
            }, function () {
                console.log("callback command");
            });
        },
        getAllSignerFields(){
            axios.post(route('proposal-generator.get-all-signature-fields'), {proposalId: '', fromWhere: 'pg'}).then(response => {
                this.allSignerFields = response.data.allFields;
            });
        },
        slugify(text) {
            return text
                .toString()
                .toLowerCase()
                .trim()
                .replace(/\s+/g, '_') // Replace spaces with hyphens
                .replace(/&/g, '_and_') // Replace & with 'and'
                .replace(/[^\w-]+/g, '') // Remove non-word characters except hyphens
                .replace(/--+/g, '_'); // Replace multiple hyphens with a single hyphen
        },
        setCustomSignatureFieldsArray(result){
            this.customInitialFields = result.customInitialFields;
            this.customSignatureFields = result.customSignatureFields;
            this.signatureInDoc = {
                customInitialFields: result.customInitialFields,
                customSignatureFields: result.customSignatureFields
            };
            this.$nextTick(() => {
                this.saveSectionSignature();
            });
        },
        getContactsDataForSignature(){
            axios.post(route('proposal-generator.get-contact-information'), {projectId: '', teamId: ''}).then(response => {
                console.log(response);
                let contactArray = [];
                if(response.data.projectContact){
                    if(response.data.projectContact.email && response.data.projectContact.email !== ''){
                        let projectContact  = {
                            contact_type: 'Project Contact',
                            contact_options: [
                                {...response.data.projectContact, type: 'project_contact', displayName: response.data.projectContact.name},
                            ]
                        };
                        contactArray.push(projectContact);
                    }
                }

                if(response.data.companyContacts.length > 0){
                    let companyContactOptions = [];
                    response.data.companyContacts.forEach(item => {
                        companyContactOptions.push({...item, type: 'company_contact', displayName: item.name+' ('+item.company_name+')'});
                    });
                    let companyContact  = {
                        contact_type: 'Company Contact',
                        contact_options: companyContactOptions
                    };
                    contactArray.push(companyContact);
                }

                if(response.data.activeTeamMember.length > 0){
                    let teamUserOptionsOptions = [];
                    response.data.activeTeamMember.forEach(item => {
                        teamUserOptionsOptions.push({...item, type: 'team_users', displayName: item.name});
                    });
                    let teamUser  = {
                        contact_type: 'Team Users',
                        contact_options: teamUserOptionsOptions
                    };
                    contactArray.push(teamUser);
                }

                let newContactOption = [];
                let item = {
                    id: 0,
                    name:'New Contact'
                };
                newContactOption.push({...item, type: 'new_contact', displayName: '+ NEW CONTACT'});

                let newContact  = {
                    contact_type: 'New Contact',
                    contact_options: newContactOption
                };
                contactArray.push(newContact);

                this.signatureUsers = contactArray;

                this.symbols = response.data.symbols;
                this.masks = response.data.masks;
                this.exchange = response.data.exchangeData;
                this.externalEmailService = response.data.externalEmailService;

                this.$nextTick(() => {
                    this.showComponent = true;
                });
            });
        },
        createSignatureField(){
            let contactData = {
                name: this.newContactName,
                email: this.newContactEmail,
            };
            axios.post(route('proposal-generator.save-new-contact-signature-field'), {proposalId: '', selectedUser: this.selectedSignatureUser, contactData: contactData}).then(response => {
                this.allSignerFields = response.data.allFields;
                this.closeCreateNewContactSignatureModal();
                this.newContactName = null;
                this.newContactEmail = null;
                this.selectedSignatureUser = null;
            });
        },
        closeCreateNewContactSignatureModal(){
            $('#createNewContactSignatureModal').modal('hide');
        },
        openCreateNewContactSignatureModal(){
            $('#createNewContactSignatureModal').modal('show');
        },
        isValidEmail(email) {
            // Regular expression pattern for a valid email address
            var pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            return pattern.test(email);
        },
        openSelectContactModal() {
            $('#createNewContactSignatureModal').modal('hide');
            $('#selectContactModal').modal('show');
        },
        openNewCompanyContactModal(){
            $('#selectContactModal').modal('hide');
            this.$refs.CompanyContactModal.open('forProposal');
        },
        openEmailContactModal(){
            $('#selectContactModal').modal('hide');
            this.$refs.EmailContactModal.open(this.project.id, 'forProposal');
        },
        parseContacts(contact) {
            this.newContactName = contact.name;
            this.newContactEmail = contact.email;
            this.$nextTick(() => {
                this.createNewContact();
            });
        },
        createNewContact(){
            if(this.newContactName === '' || this.newContactName == null || this.newContactName.trim() == ''){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please add contact name'
                });
                return false;
            }

            if(this.newContactEmail === '' || this.newContactEmail == null || this.newContactEmail.trim() === '' || !this.isValidEmail(this.newContactEmail)){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please add valid email address'
                });
                return false;
            }
            let contactData = {
                name: this.newContactName,
                email: this.newContactEmail,
            };
            axios.post(route('proposal-generator.save-new-contact-signature-field'), {proposalId: '', selectedUser: this.selectedSignatureUser, contactData: contactData}).then(response => {
                this.allSignerFields = response.data.allFields;
                this.closeCreateNewContactSignatureModal();
                this.newContactName = null;
                this.newContactEmail = null;
                this.selectedSignatureUser = null;
                this.$refs.CompanyContactModal.close();
                this.$refs.EmailContactModal.close();
                Bus.$emit('allCustomSignatures1', response.data.allFields);
            });

        },
        saveSectionSignature(fromWhere = null){
            axios.post(route('proposal.only-office.save-sign'), {contentId: this.proposalContentText.id, customInitialFields: this.customInitialFields, customSignatureFields: this.customSignatureFields})
                .then((response) => {
                    this.signatureInDoc = response.data.proposalCustomSecton;
                });
        },
    },
    watch:{
        selectedSignatureUser(val){
            if(val && val.id == 0){
                this.openCreateNewContactSignatureModal();
            }else if(val && val.id != 0){
                this.createSignatureField();
            }
        }
    },
};
</script>

<style>
#proposal-settings-template-manage-div {
    padding: 5px 0;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);
    background-color:#fff;
    min-height: 80vh;
    border-radius:5px;
}
#proposal-settings-template-manage-div h5{
    color: #222;
    font-weight: 400;
    padding: 5px 0px;
}
#proposal-settings-template-manage-div .add-new-template-button{
    height: 40px;
    font-weight: 300;
}
.tool-buttons {
    border: 1px solid #01b1af;
    margin: 0 5px;
    font-size: 12px;
    padding: 10px 0;
    color: #01b1af;
    text-align: center;
    margin-bottom: 9px;
    max-width: 93% !important;
    margin-right: 5px;
    margin-left: 7px;
}
.tool-buttons:hover {
    background-color: #01b1af1c;
    cursor: pointer;
}
.embedded-header-footer .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff !important;
    background-color: #01b1af !important;
    border-color: #01b1af !important;
}
</style>

